var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"hide-header":true,"hide-footer":true,"content-class":"modal-blue","id":"key-vocabulary-modal","centered":""},on:{"shown":function($event){return _vm.onShown()}}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9f2c668","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lab/key-vocabulary-modal.vue
// module id = 1109
// module chunks = 12